<template>
    <div class="h-100">
        <admin-nav class="openNav"></admin-nav>

        <div class="contentContainer h-100 openNavContent">
            <router-view />
        </div>
    </div>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
import { mapGetters } from 'vuex';
import AdminNav from './components/Nav';
import { BButton, BIcon, BIconChevronDoubleRight, BIconChevronDoubleLeft } from 'bootstrap-vue'

export default {
    components: {
        AdminNav,
        BButton,
        BIcon,
        BIconChevronDoubleRight,
        BIconChevronDoubleLeft
    },
    name: 'editor.admin',
    computed: {
        ...mapGetters(['editorError']),
    },

    watch: {
        editorError(newValue) {
            console.error(newValue.message);

            this.$bvToast.toast(newValue.message, {
                title: newValue.title ? newValue.title : newValue.type + ' ' + newValue.name,
                autoHideDelay: 8000,
                variant: "warning",
                appendToast: false
                }
            );
        }
    },

}
</script>

<style lang="scss" scoped>
    .navToggle {
        position: fixed;
        top: 0.5rem;
        left: 0.5rem;
        z-index: 1;
    }
    .error {
        position: absolute;
        bottom: 0px;
        left: 0px;
        padding: 0.2rem;
        width: 100%;
        margin-bottom: 0;
    }

    .openNav {
        width: 15rem;
    }

    .contentContainer {
        transition: margin-left .5s; /* If you want a transition effect */
    }

    .openNavContent {
        margin-left: 15rem;
    }
</style>
